import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { getSeatAvailabilityPreviewForShowtime, loadSeatAvailabilityPreviewForShowtime, loadSeatLayoutForShowtime, logger } from '@vista-digital/occ-domain';
import { LoadingState } from '@vista-digital/utilities';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useOccConfig } from '../../context/occ/hooks/use-occ-config';
import { SeatPicker } from '../../subcomponents/seat-picker/seat-picker';
import { SeatPickerSkeleton } from '../../subcomponents/seat-picker/subcomponents/skeleton';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { ShowtimeSeatPreviewMessage, ShowtimeSeatPreviewMessageType } from './subcomponents/message';
import { defaultShowtimeSeatPreviewProps, showtimeSeatPreviewPropsValidator } from './types/props';
import { getSeatingDataForShowtime } from './utils/seating-data-utils';
const b = bemClassBuilder('v-showtime-seat-preview');
const ShowtimeSeatPreview = observer(props => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { showtimeId, displayText, assets, config, subcomponents } = props;
    const [loadingState, setLoadingState] = useState(LoadingState.Loading);
    useEffect(() => {
        (async () => {
            try {
                await Promise.all([
                    loadSeatLayoutForShowtime(showtimeId),
                    loadSeatAvailabilityPreviewForShowtime(showtimeId)
                ]);
                setLoadingState(LoadingState.Success);
            }
            catch (error) {
                logger.error(error);
                setLoadingState(LoadingState.Failure);
            }
        })();
    }, [showtimeId]);
    const seatingData = getSeatingDataForShowtime(showtimeId);
    const seatAvailability = getSeatAvailabilityPreviewForShowtime(showtimeId);
    if (loadingState === LoadingState.Failure) {
        return (_jsx(ShowtimeSeatPreviewMessage, { type: ShowtimeSeatPreviewMessageType.FailedToLoadData, displayText: displayText, assets: assets }));
    }
    if (loadingState === LoadingState.Loading || !seatingData) {
        return enableSkeletonLoadingIndicators ? _jsx(SeatPickerSkeleton, { config: config }) : null;
    }
    if (seatAvailability === null || seatAvailability === void 0 ? void 0 : seatAvailability.isSoldOut) {
        return (_jsx(ShowtimeSeatPreviewMessage, { type: ShowtimeSeatPreviewMessageType.SoldOut, displayText: displayText, assets: assets }));
    }
    return (_jsx("div", { className: b.block(), children: _jsx(SeatPicker, { data: seatingData, selectedSeatIds: [], displayText: displayText, assets: assets, config: config, events: {}, subcomponents: subcomponents }) }));
});
ShowtimeSeatPreview.displayName = 'ShowtimeSeatPreview';
/**
 * The **Showtime Seat Preview** component renders a **Seat Picker** component for showtime.
 */
export const ShowtimeSeatPreviewComponent = withComponentWrapper(ShowtimeSeatPreview, defaultShowtimeSeatPreviewProps, showtimeSeatPreviewPropsValidator);
//# sourceMappingURL=showtime-seat-preview.js.map